import { NpyReader } from './readers/NpyReader';
import { PfmReader } from './readers/PfmReader';
import { PngReader } from './readers/PngReader';
import { TifReader } from './readers/TifReader';
import { ExrReader } from './readers/ExrReader';
const readers = [];
export function registerReader(reader) {
    readers.push(reader);
}
export function registerDefaultReaders() {
    // Register depth format readers
    registerReader(new PfmReader());
    registerReader(new TifReader());
    registerReader(new NpyReader());
    registerReader(new PngReader());
    registerReader(new ExrReader());
    // Note: Rgb24Reader is no longer used as a reader.
    // RGB24 conversion is now handled by TifReader and PngReader directly
    // after they detect RGB images at runtime using Rgb24Converter utility.
}
export function findReader(filename, mimeType) {
    // Search from the END to prioritize most recently registered readers
    // This allows custom-configured readers to override default readers
    for (let i = readers.length - 1; i >= 0; i--) {
        if (readers[i].canRead(filename, mimeType)) {
            return readers[i];
        }
    }
    return undefined;
}
export async function readDepth(filename, buf) {
    const reader = findReader(filename);
    if (!reader) {
        throw new Error(`No depth reader registered for ${filename}`);
    }
    console.log(`[DepthRegistry] Selected reader for ${filename}: ${reader.constructor.name}`);
    return reader.read(buf);
}
// For testing purposes - clear all registered readers
export function clearReaders() {
    readers.length = 0;
}
